import { MessageCircle, Lock, Clock } from "lucide-react";
import { Reveal } from "../motion/Reveal";
import { CONSULT_IMG } from "../../data/academyData";

const points = [
  { icon: MessageCircle, text: "Real, ongoing, expert chat access. Not a chatbot or a one-time consultation." },
  { icon: Lock, text: "Complete privacy. Ask what you've always been too embarrassed to ask." },
  { icon: Clock, text: "Available whenever you need it, a lifetime of guidance, not just a course." },
];

export const ConsultationHighlight = () => (
  <section id="consultation" data-testid="consultation-highlight-section" className="relative py-20 md:py-32 bg-[#0A0A0D] border-t border-white/[0.06]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <Reveal>
        <div className="rounded-3xl overflow-hidden border border-white/10">
          <img src={CONSULT_IMG} alt="A couple connecting warmly over candlelight, representing private consultation support" className="w-full h-auto object-cover" />
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold mb-4">Included With Membership</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-white leading-tight">
          Ongoing 1-on-1 Consultation With Aradhya Herself.
        </h2>
        <p className="mt-6 text-zinc-400 text-lg leading-relaxed">
          This alone is worth more than the entire membership price. Get direct, private access for your sexual health questions, relationship struggles, and personal growth.
        </p>
        <div className="mt-8 space-y-5">
          {points.map((p) => (
            <div key={p.text} className="flex items-start gap-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-500/10 text-amber-400"><p.icon size={18} /></span>
              <p className="text-zinc-300 pt-2">{p.text}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
